import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const categoriesList = css`
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 271px);
  gap: var(--space-500) var(--space-400);
  width: 100%;
  padding: 0;
  margin: var(--space-400) 0 var(--space-1000);
  list-style: none;

  ${breakpoints.only.desktop} {
    grid-template-columns: repeat(auto-fill, 292px);
  }
  ${breakpoints.only.tablet} {
    grid-template-columns: repeat(auto-fill, 314px);
  }
  ${breakpoints.only.mobile} {
    grid-template-columns: repeat(auto-fill, 100%);
    gap: var(--space-300);
  }
`;
